<template>
  <div class="achievement-analysis-grade">
    <!-- 顶部选择条件和一些按钮 -->
    <achievementTopBar ref="topBar" :semester="searchInfo.semester" :schoolYear="searchInfo.schoolYear"
      :semesterOptions="semesterOptions" :gradeList="gradeList" :examTitleList="examTitleList"
      @externalScoreEntry="externalScoreEntry" @pointSystemEntry="pointSystemEntry" @scoreIndexEntry="scoreIndexEntry"
      @deleteGradeClick="deleteGradeClick" @createExam="createExam" @editExam="editExam" @scoreEntry="scoreEntry"
      @gradeComparison="gradeComparison" @gradeExamSearch="gradeExamSearch"
      @externalPerformanceComparison="externalPerformanceComparison" @examRankComparison="examRankComparison"
      @scoreAnalyze="scoreAnalyze" />
    <!-- 年级考试列表 -->
    <div class="exam-list-box" v-bitmap="achievementListGetResult">
      <achievementList ref="achievementList" @gradeAchievementChange="gradeAchievementChange"
        @viewClassExam="viewClassExam" :searchData="searchData" :gradeExamInfoList="gradeExamInfoList"
        :courseFullList="courseFullList" />
    </div>
    <!-- 分页 -->
    <div class="achievement-pagination">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageSize)" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange" />
    </div>
    <!-- 校外成绩录入弹窗 -->
    <externalScoreEntryDialog v-show="externalScoreEntryShow" :externalScoreEntryShow.sync="externalScoreEntryShow"
      :schoolCourseList="schoolCourseList" @externalScoreEntryConfirm="externalScoreEntryConfirm" />
    <!-- 科目分制录入弹窗 -->
    <pointSystemEntryDialog v-show="pointSystemEntryShow" :pointSystemEntryShow.sync="pointSystemEntryShow"
      :schoolCourseList="schoolCourseList" :gradeList="gradeList" @pointSystemEntryConfirm="pointSystemEntryConfirm"
      @pointEntryGradeChange="pointEntryGradeChange" />
    <!-- 科目分数指标录入弹窗 -->
    <scoreIndexEntryDialog v-show="scoreIndexEntryShow" :scoreIndexEntryShow.sync="scoreIndexEntryShow"
      :schoolCourseList="schoolCourseList" :gradeList="gradeList" @scoreIndexEntryConfirm="scoreIndexEntryConfirm"
      @scoreIndexEntryGradeChange="scoreIndexEntryGradeChange" />
    <!-- 创建考试弹窗 -->
    <createExamDialog v-show="createExamShow" :createExamShow.sync="createExamShow"
      @createExamConfirm="createExamConfirm" :semester="searchInfo.semester" :schoolYear="searchInfo.schoolYear"
      :semesterOptions="semesterOptions" :isStatisticsTypeList="isStatisticsTypeList" :isExternalList="isExternalList"
      :examTitleList="examTitleList" :gradeList="gradeList" />
    <!-- 修改考试弹窗 -->
    <editExamDialog v-if="editExamShow" :editExamShow.sync="editExamShow" @editExamConfirm="editExamConfirm"
      :semesterOptions="semesterOptions" :isStatisticsTypeList="isStatisticsTypeList" :isExternalList="isExternalList"
      :examTitleList="examTitleList" :editExamInfo="editExamInfo" :gradeList="gradeList" />
    <!-- 成绩录入弹窗 -->
    <scoreEntryDialog v-if="scoreEntryShow" :scoreEntryShow.sync="scoreEntryShow" :gradeSelectList="gradeSelectList"
      :courseFullList="courseFullList" :gradeStudentList="gradeStudentList" :selectClass="selectClass"
      :classSelectList="classSelectList" />
    <!-- 学生成绩对比弹窗 -->
    <gradeComparisonDialog v-show="gradeComparisonShow" :gradeComparisonShow.sync="gradeComparisonShow"
      :labelConditionList="labelConditionList" :classStudentList="classStudentList" :comparativeExamData="comparativeExamData"
      :gradeStudentList="gradeStudentList" @searchLabelName="getLabelConditionList" />
    <!-- 选择校外标识弹窗 -->
    <selectExternalDialog v-if="selectExternalDialogShow" :externalList="externalList"
      :selectExternalDialogShow.sync="selectExternalDialogShow"
      @selectExternalConfirm="externalPerformanceComparisonDialogShow" />
    <!-- 成绩对比雷达图弹窗 -->
    <gradeExternalChartDialog v-if="externalChartDialogShow" :externalChartDialogShow.sync="externalChartDialogShow"
      :scoreGradeContrastData="scoreGradeContrastData" :courseFullList="courseFullList" />
    <!-- 考试名次对比-选择名次弹窗 -->
    <examRankComparisonSelectDialog v-if="examRankComparisonSelectDialogShow" :examRankComparisonSelectDialogShow.sync="examRankComparisonSelectDialogShow
      " @selectExamRankConfirm="selectExamRankConfirm" />
    <!-- 考试名次对比-表格弹窗 -->
    <examRankComparisonTableDialog v-if="examRankComparisonTableDialogShow" :examRankComparisonTableDialogShow.sync="examRankComparisonTableDialogShow
      " :examRankList="examRankList" :examRankComparisonList="examRankComparisonList"
      :gradeSelectList="gradeSelectList" />
  </div>
</template>

<script>
import achievementTopBar from "./components/achievement-top-bar/achievementTopBar.vue";
import pagination from "@/components/pagination/pagination";
import achievementList from "./components/achievement-list/achievementList.vue";
import externalScoreEntryDialog from "./components/external-score-entry-dialog/externalScoreEntryDialog.vue";
import pointSystemEntryDialog from "./components/point-system-entry-dialog/pointSystemEntryDialog.vue";
import scoreIndexEntryDialog from "./components/score-index-entry-dialog/scoreIndexEntryDialog.vue";
import createExamDialog from "./components/create-exam-dialog/createExamDialog.vue";
import editExamDialog from "./components/edit-exam-dialog/editExamDialog.vue";
import scoreEntryDialog from "./components/score-entry-dialog/scoreEntryDialog.vue";
import gradeComparisonDialog from "./components/grade-comparison-dialog/gradeComparisonDialog.vue";
import selectExternalDialog from "./components/select-external-dialog/selectExternalDialog.vue";
import gradeExternalChartDialog from "./components/grade-external-chart-dialog/gradeExternalChartDialog.vue";
import examRankComparisonSelectDialog from "./components/select-exam-rank-comparison-dialog/examRankComparisonSelectDialog.vue";
import examRankComparisonTableDialog from "./components/table-exam-rank-comparison-dialog/examRankComparisonTableDialog.vue";
import { baseURL } from "@/api/request"; // 服务器地址

export default {
  components: {
    achievementTopBar,
    achievementList,
    pagination,
    externalScoreEntryDialog,
    pointSystemEntryDialog,
    scoreIndexEntryDialog,
    createExamDialog,
    editExamDialog,
    scoreEntryDialog,
    gradeComparisonDialog,
    selectExternalDialog,
    gradeExternalChartDialog,
    examRankComparisonSelectDialog,
    examRankComparisonTableDialog,
  },
  data() {
    return {
      searchInfo: {
        semester: "", // 学期
        schoolYear: "", // 学年
      },
      semesterOptions: [], // 学期选择数据列表
      gradeList: [], // 年级列表
      gradeExamInfoList: [], // 年级考试列表
      examTitleList: [], // 考试主标题列表
      // 分页参数
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      gradeSelectList: [], // 年级考试复选选择列表
      externalScoreEntryShow: false, // 控制校外成绩录入弹窗显示
      pointSystemEntryShow: false, // 控制科目分制录入弹窗显示
      scoreIndexEntryShow: false, // 控制科目分数指标录入弹窗显示
      createExamShow: false, // 控制创建考试弹窗显示
      editExamShow: false, // 控制修改考试弹窗显示
      editExamInfo: null, // 需要修改的考试信息
      scoreEntryShow: false, // 控制成绩录入弹窗显示
      gradeComparisonShow: false, // 学生成绩对比弹窗
      isStatisticsTypeList: [], // 是否统计选择列表
      isExternalList: [], // 是否对外选择列表
      // 查询参数
      searchData: {
        gradeId: "",
        title: "",
        subTitle: "",
        startTime: "",
        schoolYear: "",
        semester: "",
      },
      schoolCourseList: [], // 学校科目列表
      scoreEntryList: [], // 已有的分数指标列表
      gradeStudentList: [], // 年级学生列表
      courseFullList: [], // 分制列表
      selectClass: null, // 选中的年级中的班级数据
      labelConditionList: [], // 学生标签列表
      comparativeExamData: [], // 对比的考试信息
      achievementListGetResult: "nullData",
      externalList: [], // 校外标识列表
      selectExternalDialogShow: false, // 选择校外标识弹窗
      externalChartDialogShow: false, // 年级成绩与校外成绩对比弹窗
      scoreGradeContrastData: [], // 年级成绩与校外成绩对比数据
      examRankComparisonSelectDialogShow: false, // 考试名次对比弹窗(选择名次)
      examRankList: [], // 考试名次对比(已选名次列表)
      examRankComparisonTableDialogShow: false, // 考试名次对比弹窗(表格)
      examRankComparisonList: [], // 考试名次对比列表
      classSelectList: [], // 班级选择列表
      classStudentList: [], // 学生成绩对比学生列表
    };
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    this.searchData = this.$route.query.searchData ? JSON.parse(this.$route.query.searchData) : {
      gradeId: "",
      title: "",
      subTitle: "",
      startTime: "",
      schoolYear: "",
      semester: "",
    };
    // 查询学校信息
    this.getSchoolDetails();
    // 获取学期类型选择列表数据
    this.getSemesterType();
    // 获取年级列表
    this.getGradeList();
    // 获取是否统计选择列表
    this.getIsStatisticsType();
    // 获取是否对外选择列表
    this.getExternalType();
    // 获取考试主标题列表
    this.getSchoolExamTitle();
    // 获取学校科目列表
    this.getCourseList();
    // 获取年级考试信息列表
    this.getSchoolExamInfoByTeacher();
  },
  mounted() {
    this.$refs.topBar.searchInfo = this.$route.query.searchData ? JSON.parse(this.$route.query.searchData) : {
      gradeId: "",
      title: "",
      subTitle: "",
      startTime: "",
      schoolYear: "",
      semester: "",
    };
  },
  methods: {
    // 成绩分析点击
    scoreAnalyze(e) {

    },
    // 考试名次对比-选择名次弹窗返回
    selectExamRankConfirm(e) {
      this.examRankList = e.map((item) => +item.rankVal);
      this.post(this.$url.selectScoreAssignedPosition, {
        examInfoIds: this.gradeSelectList,
        rankings: this.examRankList,
      }).then((res) => {
        console.log("获取考试名次对比列表==>", res);
        this.examRankComparisonList = res.data;
        this.examRankComparisonTableDialogShow = true;
      });
    },
    // 点击考试名次对比
    examRankComparison(e) {
      // if (!this.gradeSelectList.length)
      //   return this.$message.warning("请选择需要对比的年级考试");
      if (this.gradeSelectList.length < 2)
        return this.$message.warning("至少选择2个考试");
      this.examRankComparisonSelectDialogShow = e;
    },
    // 点击校外成绩对比
    externalPerformanceComparison(e) {
      if (!this.gradeSelectList.length)
        return this.$message.warning("请选择需要对比的年级考试");
      if (this.gradeSelectList.length > 1)
        return this.$message.warning("最多选择一个考试");
      this.getExternalAchievementPC();
    },
    // 获取校外标识
    getExternalAchievementPC() {
      this.get(this.$url.getExternalAchievementPC, {
        gradeId: this.gradeExamInfoList.find(
          (item) => item.id == this.gradeSelectList[0]
        ).gradeId,
        examInfoId: this.gradeSelectList[0],
        schoolId: this.user.schoolId,
      }).then((res) => {
        // console.log("获取校外标识列表==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        if (res.total === 0) return this.$message.warning("未录入校外成绩");
        this.externalList = res.rows;
        this.selectExternalDialogShow = true;
      });
    },
    // 选择完对比的校外标识后点击下一步
    externalPerformanceComparisonDialogShow(e) {
      let data = {
        outsideSchoolSign: e,
        gradeId: this.gradeExamInfoList.find(
          (item) => item.id == this.gradeSelectList[0]
        ).gradeId,
        examInfoId: this.gradeSelectList[0],
      };
      // console.log("this.gradeExamInfoList:", this.gradeExamInfoList);
      this.post(this.$url.selectScoreGradeExtramuralContrast, data).then(
        (res) => {
          // console.log("获取单个年级和校外平均分对比", res);
          if (res.code !== 200) return this.$message.error(res.msg);
          this.scoreGradeContrastData = [
            {
              avgScoreList: res.data,
              gradeName: this.gradeExamInfoList.find(
                (item) => item.id == this.gradeSelectList[0]
              ).gradeName,
              outsideSchoolSign: e,
              gradeId: this.gradeExamInfoList.find(
                (item) => item.id == this.gradeSelectList[0]
              ).gradeId,
              examInfoId: this.gradeSelectList[0],
            },
          ];
          this.externalChartDialogShow = true;
          this.selectExternalDialogShow = false;
        }
      );
    },
    // 获取年级学生列表
    selectStudentListPC(gradeId) {
      let data = {
        schoolId: this.user.schoolId,
        gradeId,
      };
      this.get(this.$url.selectStudentListPC, data).then((res) => {
        // console.log("获取年级学生列表：", res);
        if (res.code !== 200) return;
        this.gradeStudentList = res.rows;
      });
    },
    // 获取学校科目列表
    getCourseList() {
      this.get(this.$url.getCourseList, {
        courseType: 0
      }).then((res) => {
        // console.log("获取学校科目列表：", res);
        if (res.code !== 200) return;
        let list = res.rows;
        let courseList = [];
        list.map((item) => {
          courseList.push({
            courseId: item.id,
            courseName: item.courseName,
            fullScore: "", // 分制分数
            checked: false, // 分制是否选中
            descriptors: [], // 分数指标列表
          });
        });

        if (this.courseFullList && this.courseFullList.length) {
          // 赋值科目分制
          this.courseFullList.forEach((item) => {
            courseList.forEach((sItem) => {
              if (sItem.courseId == item.courseId) {
                sItem.fullScore = item.fullScore;
                sItem.checked = true;
              }
            });
          });
        }

        // 获取指标时若有数据则赋值到对应科目的descriptors中
        if (this.scoreEntryList && this.scoreEntryList.length) {
          this.scoreEntryList.forEach((sItem) => {
            courseList.forEach((item) => {
              if (item.courseId == sItem.courseId) {
                // console.log("item:", item);
                item.descriptors.push({
                  desc: sItem.desc,
                  minScore: sItem.minScore,
                  maxScore: sItem.maxScore,
                  externalShow: sItem.externalShow,
                });
              }
            });
          });
        }

        this.schoolCourseList = courseList;
      });
    },
    // 筛选条件
    gradeExamSearch(data) {
      this.searchData = data;
      this.getSchoolExamInfoByTeacher();
    },
    // 刷新
    refresh() {
      this.pageNum = 1;
      this.total = 0;
      this.gradeSelectList = [];
      this.$refs.achievementList.checkList = []; // 组件考试列表中复选列表
      this.getSchoolExamTitle(); // 获取考试标题列表
      this.getSchoolExamInfoByTeacher(); // 获取考试信息
    },
    // 获取考试主标题列表
    getSchoolExamTitle() {
      let data = {
        schoolId: this.user.schoolId,
      };
      this.get(this.$url.getSchoolExamTitle, data).then((res) => {
        // console.log("获取考试主标题列表==>", res);
        if (res.code !== 200) return;
        this.examTitleList = res.data;
      });
    },
    // 获取年级考试信息列表
    getSchoolExamInfoByTeacher() {
      this.gradeExamInfoList = [];
      // this.achievementListGetResult = "loading";
      let { title, startTime, gradeId, subTitle, semester, schoolYear } =
        this.searchData;
      let data = {
        schoolId: this.user.schoolId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        title,
        startTime,
        gradeId,
        subTitle,
      };
      // semester和schoolYear不为空时再添加到请求参数中，不然获取列表会直接返回空
      if (semester !== "") {
        data["semester"] = semester;
      }
      if (schoolYear !== "") {
        data["schoolYear"] = schoolYear;
      }
      this.get(this.$url.getSchoolExamInfoByTeacher, data).then((res) => {
        // console.log("获取年级考试信息列表", res);
        if (res.code !== 200) {
          this.achievementListGetResult = "error";
          return this.$message.error(res.msg || "获取年级考试列表失败");
        }

        if (res.total == 0) {
          this.achievementListGetResult = "nullData";
          this.total = res.total;
          return;
        }

        this.achievementListGetResult = "success";
        this.total = res.total;
        this.gradeExamInfoList = res.rows;
      });
    },
    // 点击查看指定班级考试信息
    viewClassExam(e) {
      let data = {
        id: e.id,
      };
      this.get(this.$url.selectClassExamInfoRank, data).then((res) => {
        // console.log("获取班级考试信息==>", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取班级考试信息失败");
        this.$router.push({
          path: "/achievement-analysis-class",
          query: {
            examInfo: JSON.stringify(res.data),
            gradeId: e.gradeId,
            gradeExamId: e.id,
            searchData: JSON.stringify(this.searchData)
          },
        });
      });
    },
    // 学生成绩对比点击
    gradeComparison(e) {
      if (!this.gradeSelectList.length)
        return this.$message.warning("请选择需要对比成绩的年级考试");
      if (this.gradeSelectList.length < 2)
        return this.$message.warning("至少选择两个考试");
      // if (this.gradeSelectList.length != 2)
      //   return this.$message.warning("只能选择两个考试");

      const getExamById = (examId) => {
        return this.gradeExamInfoList.find((exam) => exam.id === examId);
      };
      const examsById = this.gradeSelectList.map((examId) =>
        getExamById(examId)
      );

      // if (examsById[0].gradeName !== examsById[1].gradeName)
      //   return this.$message.warning("请选择同一年级的考试");
      this.comparativeExamData = examsById;
      this.getLabelConditionList();
      this.selectStudentComparativeAnalysis(); // 获取学生成绩对比班级学生列表

      // // 获取年级学生列表
      this.selectStudentListPC(
        this.gradeExamInfoList.find(
          (item) => item.id == this.gradeSelectList[0]
        ).gradeId
      );
      this.gradeComparisonShow = e;
    },
    // 学生成绩对比班级学生列表
    selectStudentComparativeAnalysis() {
      // 构造新的URL
      let finalURL = this.buildUrlWithMultipleParams(this.$url.selectStudentComparativeAnalysis, 'examInfoIds', this.gradeSelectList);

      this.get(finalURL).then((res) => {
        // console.log(res);
        if (res.code !== 200) return;
        this.classStudentList = res.data;
      })
    },
    buildUrlWithMultipleParams(portURL, paramName, values) {
      let url = new URL(portURL, baseURL); // 创建URL对象

      // 遍历值数组，并为每个值添加参数
      values.forEach(value => {
        url.searchParams.append(paramName, value);
      });

      return url.toString(); // 返回最终的URL字符串
    },
    // 查询学生标签列表-学生成绩对比选择标签对比方式时用到
    getLabelConditionList(e) {
      let data = {
        schoolId: this.user.schoolId,
        labelName: e || "",
      };
      this.post(this.$url.getLabelConditionList, data).then((res) => {
        if (res.code !== 200) return;
        this.labelConditionList = res.data;
      });
    },
    // 成绩录入点击
    scoreEntry(e) {
      // console.log("this.gradeSelectList:", this.gradeSelectList);
      if (!this.gradeSelectList.length)
        return this.$message.warning("请选择需要录入成绩的年级考试");
      if (this.gradeSelectList.length > 1)
        return this.$message.warning("最多选择一个考试");
      // 获取考试科目分制
      this.getPointSystem(
        this.gradeExamInfoList.find(
          (item) => item.id == this.gradeSelectList[0]
        ).gradeId
      );
      // 获取年级学生列表
      this.selectStudentListPC(
        this.gradeExamInfoList.find(
          (item) => item.id == this.gradeSelectList[0]
        ).gradeId
      );

      this.scoreEntryShow = e;
    },
    // 修改考试点击提交
    editExamConfirm(data) {
      this.put(this.$url.updateGradeExamInfo, data).then((res) => {
        if (res.code !== 200)
          return this.$message.error(res.msg || "修改考试失败");
        this.$message.success(res.msg || "修改考试成功");
        this.editExamShow = false;
        this.refresh();
      });
    },
    // 修改考试点击
    editExam(e) {
      if (!this.gradeSelectList.length)
        return this.$message.warning("请选择需要修改的年级考试");
      if (this.gradeSelectList.length > 1)
        return this.$message.warning("最多选择一个考试");
      this.editExamShow = e;
      this.editExamInfo = this.gradeExamInfoList.find(
        (item) => item.id == this.gradeSelectList[0]
      );
    },
    // 创建考试点击提交
    createExamConfirm(data) {
      this.createExamShow = false;
      this.refresh();
      // this.post(this.$url.insertGradeExamInfo, data).then((res) => {
      //   if (res.code !== 200)
      //     return this.$message.error(res.msg || "创建考试失败");
      //   this.$message.success(res.msg || "创建考试成功");
      //   this.createExamShow = false;
      //   this.refresh();
      // });
    },
    // 创建考试点击
    createExam(e) {
      this.createExamShow = e;
    },
    // 删除年级考试
    deleteGradeClick() {
      console.log(this.gradeSelectList)
      if (!this.gradeSelectList.length) {
        return this.$message.warning("请先选择需要删除的年级考试");
      }
      if (this.gradeSelectList.length > 1)
        return this.$message.warning("最多选择一个考试");
      this.$confirm("是否确定删除选中的年级考试?", "删除年级考试", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.delete(
            this.$url.deleteGradeExamInfo + "?id=" + this.gradeSelectList[0]
          ).then((res) => {
            if (res.code !== 200)
              return this.$message.error(res.msg || "删除考试失败");
            this.$message.success(res.msg || "删除考试成功");
            this.refresh();
          });
        })
        .catch(() => { });
    },
    // 科目分数指标录入点击提交
    scoreIndexEntryConfirm(courseData) {
      let data = {
        schoolId: this.user.schoolId,
        ...courseData,
      };
      this.post(this.$url.addCourseGrade, data).then((res) => {
        // console.log("添加科目分数指标：", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "添加科目分数指标失败");
        this.$message.success(res.msg || "添加科目分数指标成功");
        this.refresh();
      });
    },
    // 科目分数指标录入点击
    scoreIndexEntry(e) {
      this.scoreIndexEntryShow = e;
      this.getScoreIndexEntry(this.gradeList[0].gradeId);
    },
    scoreIndexEntryGradeChange(e) {
      this.getScoreIndexEntry(e);
    },
    // 获取分数指标
    getScoreIndexEntry(e) {
      let data = {
        schoolId: this.user.schoolId,
        gradeId: e,
      };
      this.get(this.$url.getCourseGradeList, data).then((res) => {
        // console.log("获取科目分数指标；", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取科目分数指标失败");
        this.scoreEntryList = res.rows;
        this.getCourseList();
      });
    },
    // 科目分制录入点击提交
    pointSystemEntryConfirm(courseData) {
      this.post(this.$url.updateCourseFull, courseData).then((res) => {
        // console.log("添加科目分制：", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "添加科目分制失败");
        this.$message.success(res.msg || "添加科目分制成功");
        this.pointSystemEntryShow = false;
        this.refresh();
      });
    },
    // 科目分制录入点击
    pointSystemEntry(e) {
      // 获取考试科目分制
      this.getPointSystem(this.gradeList[0].gradeId);
      this.pointSystemEntryShow = e;
    },
    pointEntryGradeChange(e) {
      // 获取考试科目分制
      this.getPointSystem(e);
    },
    // 获取考试科目分制
    getPointSystem(e) {
      let data = {
        schoolId: this.user.schoolId,
        gradeId: e,
      };
      this.get(this.$url.getCourseFullList, data).then((res) => {
        // console.log("获取科目分制；", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取科目分制失败");
        if (res.total !== 0) {
          res.rows.forEach((item) => {
            item.examInfoId = this.gradeSelectList[0]; // 成绩录入用
            item.score = ""; // 成绩录入用
          });
        }
        this.courseFullList = res.rows;
        this.getCourseList();
      });
    },
    // 校外成绩录入点击提交
    externalScoreEntryConfirm(externalData) {
      let data = {
        schoolId: this.user.schoolId,
        gradeId: this.gradeExamInfoList.find(
          (item) => item.id == this.gradeSelectList[0]
        ).gradeId,
        examInfoId: this.gradeSelectList[0],
        ...externalData,
      };
      this.post(this.$url.addExternalAchievementPlenty, data).then((res) => {
        // console.log("添加校外成绩：", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "添加校外成绩失败");
        this.$message.success(res.msg || "添加校外成绩成功");
        this.externalScoreEntryShow = false;
        this.refresh();
      });
    },
    // 校外成绩录入点击
    externalScoreEntry(e) {
      if (!this.gradeSelectList.length)
        return this.$message.warning("请选择考试信息");
      this.externalScoreEntryShow = e;
    },
    // 年级考试复选切换选中
    gradeAchievementChange(e) {
      this.gradeSelectList = e;
      if (!e.length) return;
      // 获取当前选中考试的年级ID，用户查询当前年级对应的班级列表，班级成绩录入时要用到
      let selectGradeId = this.gradeExamInfoList.find(
        (gItem) => gItem.id == e[0]
      ).gradeId;
      this.selectClass = this.gradeList.find(
        (item) => item.gradeId == selectGradeId
      );
    },
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        this.searchInfo.semester = res.data.semester;
        this.searchInfo.schoolYear = res.data.schoolYear;
      });
    },
    // 获取学期类型选择列表数据
    getSemesterType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        this.semesterOptions = res.data;
      });
    },
    // 获取年级列表
    getGradeList() {
      this.get(this.$url.getgradeList, {
        schoolId: this.school.id,
      }).then((res) => {
        if (res.code == 200) {
          this.gradeList = res.data;

          if (res.data.length) {
            res.data.forEach((gItem, g) => {
              let { gradeCode, gradeId, gradeName } = gItem;
              gItem.value = {
                gradeCode,
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classCode, classId, className } = cItem;
                cItem.value = {
                  classCode,
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classSelectList = res.data;
          }
        }
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getSchoolExamInfoByTeacher();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getSchoolExamInfoByTeacher();
    },
    // 是否统计列表
    getIsStatisticsType() {
      this.get(`${this.$url.getDictType}/is_statistics`).then((res) => {
        this.isStatisticsTypeList = res.data;
      });
    },
    // 是否对外列表
    getExternalType() {
      this.get(`${this.$url.getDictType}/is_external `).then((res) => {
        // console.log("是否对外==>", res);
        this.isExternalList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementAnalysisGrade.scss";
</style>
